import React from 'react';
import { Button } from 'react-bootstrap';
import { FaUsers, FaSearchLocation, FaStore, FaPhoneAlt } from 'react-icons/fa';
import { GiCampfire } from 'react-icons/gi';
import { isCampEssentialsEnabled } from '../../../utils/featureFlags';

export function buildCommunityItems({
  onOpenBuddies,
  onOpenCampEssentials,
  onOpenFindClub,
  onOpenFindProcessor,
  onSuggestStore,
  campEssentialsEnabled = isCampEssentialsEnabled(),
}) {
  const items = [
    {
      id: 'buddies',
      title: 'Hunting Buddies',
      description: 'See buddies, statuses, and sign-outs; jump into DMs.',
      icon: <FaUsers size={22} />,
      actionLabel: 'Open Hunting Buddies',
      disabled: !onOpenBuddies,
      onClick: onOpenBuddies,
    },
    {
      id: 'find-club',
      title: 'Find a Club',
      description: 'Discover listed clubs near you and join with an invite code.',
      icon: <FaSearchLocation size={22} />,
      actionLabel: 'Find a Club',
      disabled: !onOpenFindClub,
      onClick: onOpenFindClub,
    },
    {
      id: 'find-processor',
      title: 'Find a Processor',
      description: 'Deer processors near you.',
      icon: <FaPhoneAlt size={22} />,
      actionLabel: 'Find a Processor',
      disabled: !onOpenFindProcessor,
      onClick: onOpenFindProcessor,
    },
  ];

  if (campEssentialsEnabled) {
    items.push({
      id: 'camp-essentials',
      title: 'Camp Essentials',
      description: 'Gear, recipes, and fireside for your crew.',
      icon: <GiCampfire size={22} />,
      actionLabel: 'Open Camp Essentials',
      disabled: !onOpenCampEssentials,
      onClick: onOpenCampEssentials,
    });
  }

  if (onSuggestStore) {
    items.push({
      id: 'suggest-store',
      title: 'Suggest a store',
      description:
        'Add a feed or seed store for the directory. Submissions are reviewed before going live.',
      icon: <FaStore size={22} />,
      actionLabel: 'Suggest a store',
      disabled: false,
      onClick: onSuggestStore,
    });
  }

  return items;
}

export function CommunityMenuContent({
  onOpenBuddies,
  onOpenCampEssentials,
  onOpenFindClub,
  onOpenFindProcessor,
  onSuggestStore,
}) {
  const items = buildCommunityItems({
    onOpenBuddies,
    onOpenCampEssentials,
    onOpenFindClub,
    onOpenFindProcessor,
    onSuggestStore,
  });

  return (
    <>
      <p className="y-toolkit-description">
        People-first features: buddies today, more social tools coming soon.
      </p>
      <div className="y-toolkit-grid">
        {items.map((item) => (
          <div className="y-tool-card" key={item.id}>
            <div className="y-tool-card-body">
              <div className="y-tool-icon" aria-hidden="true">
                {item.icon}
              </div>
              <div>
                <div className="y-tool-card-title">{item.title}</div>
                <div className="y-tool-card-description">{item.description}</div>
              </div>
            </div>
            <Button
              variant="light"
              className="y-tool-card-action"
              disabled={item.disabled}
              onClick={() => {
                if (item.disabled || !item.onClick) return;
                item.onClick();
              }}
            >
              {item.actionLabel}
            </Button>
          </div>
        ))}
      </div>
    </>
  );
}
